// PlayerCountInput — ActivityWizard Steg 2 (delspår multi-bana). Counter-stepper that
// hops by PLAYER_STEP (4 = padel standard, beslut #2): 4 → 8 → 12 → 16 … Clamped to
// [min, max] where max = auto-pool capacity (courts × 4, beslut #3). A stepper (not a free
// NumberInput) enforces multiples of 4 by construction and avoids the onChange lint rule.

import { Minus, Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export const PLAYER_STEP = 4;

interface PlayerCountInputProps {
  value: number;
  min: number;
  max: number;
  onValueChange: (value: number) => void;
}

export default function PlayerCountInput({ value, min, max, onValueChange }: PlayerCountInputProps) {
  const { t } = useTranslation("admin");
  const clamp = (v: number) => Math.max(min, Math.min(max, v));
  const atMin = value <= min;
  const atMax = value >= max;
  const btn =
    "flex h-11 w-11 items-center justify-center rounded-xl border border-border bg-card text-foreground transition-colors hover:border-primary/50 disabled:opacity-40 disabled:hover:border-border";

  return (
    <div className="flex items-center justify-between rounded-2xl border border-border bg-card p-3">
      <button
        type="button"
        aria-label="minska"
        data-testid="player-count-dec"
        disabled={atMin}
        onClick={() => onValueChange(clamp(value - PLAYER_STEP))}
        className={btn}
      >
        <Minus className="h-4 w-4" />
      </button>
      <div className="text-center">
        <span data-testid="player-count" className="block text-3xl font-bold leading-none tabular-nums">
          {value}
        </span>
        <span className="mt-1 block text-xs text-muted-foreground">
          {t("activityWizard.step3.playerCountUnit", { defaultValue: "platser" })}
        </span>
      </div>
      <button
        type="button"
        aria-label="öka"
        data-testid="player-count-inc"
        disabled={atMax}
        onClick={() => onValueChange(clamp(value + PLAYER_STEP))}
        className={cn(btn)}
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
}
